<template>
  <div class="intelligentWorkOrder-page">
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="home_banner product_banner">
			<div class="zbox">
				<div class="product_banner_left">
					<b>百倍云智能工单</b>
					<p>一切只为高效的流转</p>
					<!-- <a href="javascript:;" class="case-see-more-btn">查看更多</a> -->
				</div>
			</div>
		</div>
		<div class="product_nr" style="width: 100%;">
			<div class="zbox">
				<ul>
					<li class="li_border width25"><a href="javascript:;">平台简介</a></li>
					<li class="width25"><a href="javascript:;">平台特点</a></li>
					<li class="width25"><a href="javascript:;">平台功能</a></li>
					<li class="width25"><a href="javascript:;">操作流程图</a></li>
					<!-- <li class="width25"><a href="javascript:;">应用案例</a></li> -->
				</ul>
			</div>
		</div>
		<div class="product_list">
			<div class="product_list0 product_list1">
				<div id="product_list1" style="height:0px;width:0px;position: relative;bottom:70px;"></div>
				<div class="zbox">
					<span class="product_list_top">
						平台简介
					</span>
					<p class="product_list1_p">
						百倍云智能工单本着灵活配置、简洁易用、高效智能的原则，致力于为企业打造移动互联的无纸化、数字化和信息化的生产办公环境。
						根据用户需求，进行业务流程、工单流转、无聊档案、客户档案、基础信息，可以满足大部分工业信息化升级。智能工单在灵活性和兼容性方面具备巨大的优势，
						可广泛用于工业制造、工业流转、工序流转、仓库存储等各个领域。
					</p>
				</div>
			</div>
			<div class="product_list0 product_list2">
				<div id="product_list2" style="height:0px;width:0px;position: relative;bottom:70px;"></div>
				<div style="background:#f5f6fa;padding-top:20px;">
					<div class="zbox">
						<span class="product_list_top">
							平台特点
						</span>
						<ul class="product3_product_list2">
							<li>
								<img src="../../html2/img/product3_1.png"/>
								<b>在线灵活配置流程、工单、档案</b>
								<p>一款可在线灵活配置的工单系统，根据实际的需求来定制属于自己的系统，可以在线配置流程模板、
								工单模板，通过业务调研、产品实施实现产品的具体化应用。</p>
							</li>
							<li>
								<img src="../../html2/img/product3_2.png"/>
								<b>高效能工单流转系统</b>
								<p>支持多种业务流程并存，互不干扰又数据相连，工单的使用场景不再局限于部门内部，可以一键将工单高效流转到其他部门。
								企业的其他业务部门也能通过发起工单来进行跨部门的写作沟通。</p>
							</li>
							<li>
								<img src="../../html2/img/product3_3.png"/>
								<b>多端协同操作</b>
								<p>提供无纸化生产办公环境，传统电脑PC办公、新型移动平台办公，智能Android设备协助办公均可支持，
								数据互通，实现办公的多样化。上下流程无缝衔接，通过工单的进行流转，彻底解决传统办公纸张浪费的现象。</p>
							</li>
							<li>
								<img src="../../html2/img/product3_4.png"/>
								<b>全方位消息提醒</b>
								<p>强大的个人工单消息提醒机制，系统会通过站内信、消息推送、微信消息提醒、手机短信提醒、邮件提醒等多种方式。
								且支持工单到期自动加急并提醒，可以非常及时的、全方位的提醒用户处理。</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="product_list0 product_list3">
				<div id="product_list3" style="height:0px;width:0px;position: relative;bottom:70px;"></div>
				<div class="product3_product_list3" style="">
					<div class="zbox">
						<span class="product_list_top">
							平台功能
						</span>
						<ul>
							<li>
								<img src="../../html2/img/product3_5.png"/>
								<b>流程配置</b>
								<p>将不同的工单步骤串起来行程流程，可以同时配置多种流程，流程之间相互不干扰，档案数据又相互同步。</p>
							</li>
							<li>
								<img src="../../html2/img/product3_6.png"/>
								<b>工单配置</b>
								<p>可以创建属于自己企业的工单业务，且支持工单自定义配置，增加相应的业务字段，有输入、下拉、多选下拉、复选框、时间、上传等选择。</p>
							</li>
							<li>
								<img src="../../html2/img/product3_7.png"/>
								<b>工单流转</b>
								<p>系统实时统计工单流程，并在首页显示，可以直观查看和处理跟我相关的一些工单事物流程，一目了然。</p>
							</li>
							<li>
								<img src="../../html2/img/product3_8.png"/>
								<b>多端协同</b>
								<p>可以同时支持PC端、Android端、PAD端进行流程处理，多端协同办公，数据实时同步。</p>
							</li>
							<li>
								<img src="../../html2/img/product3_9.png"/>
								<b>档案配置</b>
								<p>可以根据实际需要配置客户档案、设备档案、产品档案等常规档案，且可以自定义档案需要实现的功能。</p>
							</li>
							<li>
								<img src="../../html2/img/product3_10.png"/>
								<b>图形统计</b>
								<p>个性化数据统计，多种形态展示，图标结合，且统计项目可以自主选择，展示需要显示的统计数据，并支持下载。</p>
							</li>
							<li>
								<img src="../../html2/img/product3_11.png"/>
								<b>消息提醒</b>
								<p>站内信、消息推送、微信消息提醒、手机短信提箱、邮件提醒等多种提醒方式。工单及时处理，绝不拖延。</p>
							</li>
							<li>
								<img src="../../html2/img/product3_12.png"/>
								<b>权限控制</b>
								<p>根据不同的角色对权限和操作页面进行配置，系统资源的合理管控，账号实行管理员合理分配制度，杜绝用户自行申请，大大提升系统的安全性。</p>
							</li>
							<li>
								<img src="../../html2/img/product3_13.png"/>
								<b>日志监控</b>
								<p>工单进行流转的每一步都会详细记载在操作日志里，管理员可以随时查看工单流转情况，并对异常信息的监控处理。</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="product_list0 product_list5">
				<div id="product_list4" style="height:0px;width:0px;position: relative;bottom:70px;"></div>
				<div class="product4_product_list3" style="">
					<div class="zbox">
						<span class="product_list_top">
							案例流程图一
						</span>
						<img class="default_img1" src="../../assets/img/caseDetails/intelligentWorkOrder/default_img1.png" alt="">
					</div>
				</div>
			</div>
			<div class="product_list0 product_list6">
				<div class="product3_product_list3" style="">
					<div class="zbox">
						<span class="product_list_top">
							案例流程图二
						</span>
						<img class="default_img2" src="../../assets/img/caseDetails/intelligentWorkOrder/default_img2.png" alt="">
					</div>
				</div>
			</div>
			<!-- <div class="product_list0 product_list5 product3_product_list4">
				<div id="product_list5" style="height:0px;width:0px;position: relative;bottom:70px;"></div>
				<div class="zbox">
					<span class="product_list_top">
						应用案例
					</span>
				<ul>
					<li>
						<a  href="programme4.html">
							<img class="img" src="../../html2/img/product3_14.png" />
							<div>
								<span id="">
									<img src="../../html2/img/product3_17.png"/>
									<p>进销存管理系统解决方案</p>
								</span>
							</div>
						</a>
					</li>
					<li>
						<a href="programme3.html">
							<img class="img" src="../../html2/img/product3_15.png"/>
							<div>
								<span id="">
									<img src="../../html2/img/product3_18.png"/>
									<p>生产看板系统解决方案</p>
								</span>
							</div>
						</a>
					</li>
					<li>
						<a href="case.html?#case9">
							<img class="img" src="../../html2/img/product3_16.png"/>
							<div>
								<span id="">
									<img src="../../html2/img/fangan31.png"/>
									<p>大型设备售后服务系统案例</p>
								</span>
							</div>
						</a>
					</li>
				</ul>
				</div>
			</div> -->
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'intelligentWorkOrder',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
}

$( function(){

  $(document).on("click",".width25", function(){
      $(this).addClass("li_border").siblings().removeClass("li_border")
      if( $(this).index() ){
        $("html, body").animate({
          scrollTop: $("#product_list" + ($(this).index() + 1)).offset().top
        }, {
          duration: 500,easing: "swing"
        });
      }else{
        $("html, body").animate({
          scrollTop: $("#product_list" + ($(this).index() + 1)).offset().top + 1 // 有偏差,补上,让导航看处于定位状态
        }, {
          duration: 500,easing: "swing"
        });
      }
    })

    $(document).on("click",".tab-item-container", function(){
      let index = $(this).attr("data-id")
      let elArr = $(".tab-item-content-container")
      for( let i = 0 , len = elArr.length ; i < len ; i++ ){
        let id = $(elArr[i]).attr("data-id")
        if( id == index ){
          $(elArr[i]).addClass("li_border")
        }else{
          $(elArr[i]).removeClass("li_border")
        }
      }
    })

    let navBtn = $('.width25')

    let navTop = parseInt( $('.product_banner').height() )

    if ($(this).scrollTop() > navTop ) {
      $('.product_nr').css({'position': 'fixed','top':0});
    }else if ($(this).scrollTop() <= navTop ) {
      $('.product_nr').css({'position': 'static'});
    }

    $(window).scroll(function() {
      // $(this) ---> window
      // 导航tab的位置
      if ($(this).scrollTop() > navTop ) {
          $('.product_nr').css({'position': 'fixed','top':0});
      }else if ($(this).scrollTop() <= navTop ) {
        $('.product_nr').css({'position': 'static'});
        $("#product_list1").css({ 'paddingTop': '0px' }) // 当所有内容恢复初始状态的时候,这个元素的padding也恢复正常
      }

      let plate1 = $("#product_list1" ).offset().top - 90
      let plate2 = $("#product_list2" ).offset().top - 90
      let plate3 = $("#product_list3" ).offset().top - 90
      let plate4 = $("#product_list4" ).offset().top - 90

      if( $(this).scrollTop() >= plate1 && $(this).scrollTop() < plate2 ){

        $( navBtn[0] ).addClass('li_border')
        $( navBtn[0] ).siblings().removeClass('li_border')

      }else if( $(this).scrollTop() >= plate2 && $(this).scrollTop() < plate3 ){

        $( navBtn[1] ).addClass('li_border')
        $( navBtn[1] ).siblings().removeClass('li_border')

      }else if( $(this).scrollTop() >= plate2 && $(this).scrollTop() < plate3 ){

        $( navBtn[2] ).addClass('li_border')
        $( navBtn[2] ).siblings().removeClass('li_border')

      }else if( $(this).scrollTop() >= plate4 ){

        $( navBtn[3] ).addClass('li_border')
        $( navBtn[3] ).siblings().removeClass('li_border')

      }

    })
})
</script>
<style  scoped>
  @import '../../html2/css/zhou.zkm.css';
	@import '../../html2/css/bbyInternet.css';
	
	.intelligentWorkOrder-page{
		
	}
	.intelligentWorkOrder-page .product_list5{
		padding-top: 30px;
		padding-bottom: 80px;
		background: rgb(245, 246, 250);
	}
	.intelligentWorkOrder-page .product_list6{
		margin: 0px;
		padding-top: 30px;
		padding-bottom: 80px;
		background: #FFFFFF;
	}
	.intelligentWorkOrder-page .product_list5 .default_img1{
		display: block;
		width: 64%;
		margin: 0 auto;
	}
	.intelligentWorkOrder-page .product_list6 .default_img2{
		display: block;
		width: 76%;
		margin: 0 auto;
	}
	.intelligentWorkOrder-page .product_list_top{
		font-size: 30px;
		display: block;
		height: auto;
		line-height: normal;
		text-align: center;
	}
</style>
